import "./subpage-header.scss";

import React from "react";
import clsx from "clsx";

const SubpageHeader = ({ title, center, smallMargin }) => {
  return (
    <div
      className={clsx(
        `subpage-header ${center && "subpage-header--center"} ${
          smallMargin && "subpage-header--small-margin"
        }`
      )}
    >
      <div className="container">
        <h1 className="subpage-header__title">{title}</h1>
      </div>
    </div>
  );
};

export default SubpageHeader;
